















import { Vue, Component } from 'vue-property-decorator'
import { ItemWho } from '../models'

@Component({
  components: {
  }
})

export default class ItemsAbout extends Vue {
  items: ItemWho[] = [
    {descr: 'Декларацию представлять не&nbsp;нужно. Учет доходов ведется автоматически в&nbsp;мобильном приложении.', img: '/static/images/official.svg',
     title: 'Без отчетов'},
    {descr: 'Регистрация без визита в&nbsp;инспекцию. В&nbsp;мобильном приложении, на&nbsp;сайте ФНС, через банк или портал госуслуг.',
     img: '/static/images/simple.svg', title: 'Просто'},
    {descr: '4%&nbsp;&ndash; с&nbsp;доходов от&nbsp;физлиц.<br>6%&nbsp;&ndash; с&nbsp;доходов от&nbsp;юрлиц и&nbsp;ИП.<br>Других обязательных платежей нет.',
     img: '/static/images/profit.svg', title: 'Выгодно'},
  ]
}
